import { useSyncExternalStore } from 'react';

/**
 * A phone in either orientation, or a desktop window dragged very small: below
 * the smallest common tablet (iPad mini portrait, 744px wide), or short (a big
 * phone on its side is wide enough but under 500px tall). The shell switches to
 * its phone layout here (header + drawer), and screens drop their write
 * actions. Tailwind's `desk:` variant is the same query inverted
 * (tailwind.config.js), so CSS and this hook always agree.
 */
export const SMALL_SCREEN_QUERY = '(max-width: 743px), (max-height: 499px)';

function subscribe(onChange: () => void) {
  if (typeof window.matchMedia !== 'function') return () => undefined;
  const mql = window.matchMedia(SMALL_SCREEN_QUERY);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}

function isSmallScreen(): boolean {
  return typeof window.matchMedia === 'function' && window.matchMedia(SMALL_SCREEN_QUERY).matches;
}

/** True on a small screen; updates live when the window resizes or rotates. */
export function useSmallScreen(): boolean {
  return useSyncExternalStore(subscribe, isSmallScreen);
}
